let modalAvailable = false;

export function markModalAvailable() {
	modalAvailable = true;
}

export function isModalAvailable() {
	return modalAvailable;
}
